/**
 * Utilidades para validaciones comunes
 */

/**
 * Valida si un valor es un array válido
 * @param {*} value - Valor a validar
 * @returns {boolean} true si es un array válido
 */
export const isValidArray = (value) => {
  return Array.isArray(value) && value.length > 0;
};

/**
 * Obtiene un array seguro (retorna array vacío si no es válido)
 * @param {*} value - Valor a convertir
 * @returns {Array} Array válido
 */
export const getSafeArray = (value) => {
  return Array.isArray(value) ? value : [];
};

/**
 * Valida si un monto es válido (mayor a 0)
 * @param {number|string} amount - Monto a validar
 * @returns {boolean} true si el monto es válido
 */
export const isValidAmount = (amount) => {
  const num = typeof amount === "string" ? parseFloat(amount) : amount;
  return !isNaN(num) && num > 0;
};

/**
 * Valida si un string no está vacío
 * @param {string} value - String a validar
 * @returns {boolean} true si el string es válido
 */
export const isValidString = (value) => {
  return typeof value === "string" && value.trim().length > 0;
};

/**
 * Valida si un email tiene formato válido
 * @param {string} email - Email a validar
 * @returns {boolean} true si el email es válido
 */
export const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};
